/*----------------------------------
- ROUTE: /resources/domaining-news/:date
----------------------------------*/

/**
 * @docs docs/features/domain-news
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import {
    buildDomainingNewsEditionRouteData,
    renderDomainingNewsEditionRoute,
} from './lib/route';

/*----------------------------------
- PAGE
----------------------------------*/

export default definePageRoute({
    path: '/resources/domaining-news/:dateKey(\\d{4}-\\d{2}-\\d{2})',
    options: { auth: false, layout: false, priority: 50 },
    data: buildDomainingNewsEditionRouteData,
    render: renderDomainingNewsEditionRoute,
});
